import { useState } from "react";
import {
  Grid,
  Typography,
  TextField,
  IconButton,
  Button,
  Box,
  Paper,
} from "@mui/material";
import { Add, Delete } from "@mui/icons-material";
import { useCreateObjetivo } from "../../../../context/SuperAdmin/OASContexts/CreateObjetivoContext";

const IndicadoresForm = () => {
  const {
    indicadores,
    addIndicador,
    editIndicador,
    deleteIndicador,
    isCreating,
    isAdding,
    setIsAdding,
  } = useCreateObjetivo();

  const [newIndicador, setNewIndicador] = useState("");

  const handleGuardar = () => {
    if (!newIndicador.trim()) return;
    addIndicador(newIndicador);
    setNewIndicador("");
    setIsAdding(false);
  };

  return (
    <Grid
      container
      direction="column"
      sx={{
        p: 2,
        borderRadius: 2,
        border: "1px solid #ccc",
        gap: 2,
        position: "relative",
        fontFamily: "Montserrat",
      }}
    >
      <Grid item>
        <Typography variant="h6" fontWeight="bold">
          Indicadores
        </Typography>
      </Grid>

      <Grid container spacing={2} direction="column">
        {/* Lista de indicadores existentes */}
        {indicadores.map((ind, index) => (
          <Grid item key={index}>
            <Paper
              sx={{
                p: 2,
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <TextField
                value={ind}
                onChange={(e) => editIndicador(index, e.target.value)}
                fullWidth
                multiline
                minRows={2}
                maxRows={6}
                disabled={isCreating}
              />
              <IconButton
                color="error"
                onClick={() => deleteIndicador(index)}
                disabled={isCreating}
              >
                <Delete />
              </IconButton>
            </Paper>
          </Grid>
        ))}

        {/* Botón de agregar o textarea nuevo */}
        <Grid item>
          {isAdding ? (
            <Box
              sx={{
                p: 2,
                border: "1px dashed #aaa",
                borderRadius: 2,
                display: "flex",
                flexDirection: "column",
                gap: 1,
              }}
            >
              <TextField
                value={newIndicador}
                onChange={(e) => setNewIndicador(e.target.value)}
                placeholder="Escribe un nuevo indicador..."
                fullWidth
                multiline
                minRows={3}
                maxRows={8}
              />
              <Box display="flex" gap={1} justifyContent="flex-end">
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#336B87",
                    fontFamily: "Montserrat",
                    "&:hover": { backgroundColor: "#285269" },
                  }}
                  onClick={handleGuardar}
                >
                  Guardar
                </Button>
                <Button
                  variant="outlined"
                  sx={{
                    color: "#336B87",
                    borderColor: "#336B87",
                    fontFamily: "Montserrat",
                    "&:hover": {
                      backgroundColor: "rgba(51,107,135,0.08)",
                      borderColor: "#336B87",
                    },
                  }}
                  onClick={() => {
                    setIsAdding(false);
                    setNewIndicador("");
                  }}
                >
                  Cancelar
                </Button>
              </Box>
            </Box>
          ) : (
            <Button
              fullWidth
              variant="outlined"
              startIcon={<Add />}
              disabled={isCreating}
              sx={{
                color: "#336B87",
                borderColor: "#336B87",
                fontFamily: "Montserrat",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "rgba(51,107,135,0.08)",
                  borderColor: "#336B87",
                },
              }}
              onClick={() => setIsAdding(true)}
            >
              Agregar indicador
            </Button>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default IndicadoresForm;
